import { applyFilters, doRequest } from "./helpers";
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";

export default class PointOfContactService {
  static async getTable(filters = null) {
    let path = "/point_of_contact/";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getForFilters(filters = null) {
    let path = "/point_of_contact/for_filters";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async get(id) {
    return doRequest("GET", `/point_of_contact/${id}`);
  }

  static async create(data) {
    return doRequest("POST", "/point_of_contact/", {
      data: omitBy(data, isNil),
    });
  }

  static async update(id, data) {
    return doRequest("PUT", `/point_of_contact/${id}`, {
      data: omitBy(data, isNil),
    });
  }

  static async delete(id) {
    return doRequest("DELETE", `/point_of_contact/${id}`);
  }
}
